<script>
  import { slide } from 'svelte/transition';
  import { inserts_enabled, previews_are_google_fonts, detected_fonts, visits, previews_are_zoomed} from '../stores'
  import Inserts_FirstVisit from '../content/inserts/OnboardingFirstVisit.svelte'
  import Inserts_SecondVisit from '../content/inserts/OnboardingSecondVisit.svelte'
  import Insert_YourFonts from '../content/inserts/YourFonts.svelte'
  // insert insert_position can be: 
  // before_previews, between_previews, after_previews, filtered_previews
  export let insert_position = 'before_previews'
  export let inbetween_counter = 1
  export let selected_previews_count = 0
  export let filtered_preview_count
  // export let random_insert

  const is_showing_extension_fonts = $detected_fonts && $detected_fonts.length > 0 && $detected_fonts[0]?.source === 'extension'
  const is_showing_system_fonts = $detected_fonts && $detected_fonts.length > 0 && $detected_fonts[0]?.source === 'system'
  const supports_local_font_access = 'queryLocalFonts' in self
  const show_font_detection_insert = is_showing_system_fonts || (is_showing_extension_fonts && supports_local_font_access)
</script>
{#if $inserts_enabled || show_font_detection_insert}

  <div class="InsertManager" transition:slide|local class:hidden={$previews_are_zoomed}>
    {#if !$previews_are_google_fonts}{#if visits.first()}
        <Inserts_FirstVisit
          {insert_position}
          {inbetween_counter}
          {selected_previews_count}
          {filtered_preview_count}
          {show_font_detection_insert}
        />
      {/if}{#if visits.second()}
        <Inserts_SecondVisit
          {insert_position}
          {inbetween_counter}
          {selected_previews_count}
          {filtered_preview_count}
          {show_font_detection_insert}
        />
      {/if}{#if visits.multiple()}
        {#if show_font_detection_insert}
          <Insert_YourFonts {insert_position}/>
        {/if}
      {/if}
    {/if}
  </div>

{/if}

<style>
  .InsertManager {
    position: relative;
    width: 100%;
  }
  .InsertManager.hidden {
    display: none;
  }
  .InsertManager:empty {
    display: none;
  }
</style>